export default __webpack_public_path__ + "static/media/4.8206a034.png";